const itemClient = {
	"DASHBOARD": {
		"type": "item",
		"label": "Dashboard",
		"link": "/dashboard",
		"icon": "PieChartOutlined",
		"iconType": "antd-icon",
		"key": 1
	},
	"COMUNICADO": {
		"type": "item",
		"label": "Noticias",
		"link": "/news",
		"icon": "co-newspaper",
		"iconType": "oh-vue",
		"key": 2
	},
	"ENCABEZADO_ACCIONES": {
		"type": "menu-item-header",
		"label": "Acciones"
	},
	"EMPRESA": {
		"type": "item",
		"label": "Empresas",
		"link": "/bussiness",
		"icon": "CloudOutlined",
		"iconType": "antd-icon",
		"key": 3,
		"empresa": true
	},
	"ACCOUNT": {
		"type": "item",
		"label": "Estado de Cuenta",
		"link": "/my_account",
		"icon": "ContainerOutlined",
		"iconType": "antd-icon",
		"key": 4
	},
	"SERVICIOS": {
		"type": "item",
		"label": "Servicios",
		"link": "/services",
		"icon": "CloudOutlined",
		"iconType": "antd-icon",
		"key": 8
	},
	"TICKETS": {
		"type": "item",
		"label": "Tickets",
		"link": "/tickets",
		"icon": "MailOutlined",
		"iconType": "antd-icon",
		"key": 5
	},
	"REFERIDO": {
		"type": "item",
		"label": "Referido",
		"link": "/referido",
		"icon": "TeamOutlined",
		"iconType": "antd-icon",
		"key": 6
	},
	// "IPTV": {
	// 	"type": "item",
	// 	"label": "Netplus IPTV",
	// 	"link": "/iptv",
	// 	"icon": "InboxOutlined",
	// 	"iconType": "antd-icon",
	// 	"key": 6
	// },
	// "HELPDESK": {
	// 	"type": "item",
	// 	"label": "Ayuda",
	// 	"link": "/helpdesk",
	// 	"icon": "CustomerServiceOutlined",
	// 	"iconType": "antd-icon",
	// 	"key": 7
	// },
}

export { itemClient }